export enum EmailSort {
  oldestOnTop = 'Oldest on top',
  newestOnTop = 'Newest on top',
  toAddress = 'Receiver Name',
  fromAddress = 'Sender Name',
  subject = 'Subject',
}
